var map = {
	"./info-aia.html": 82,
	"./info-anchor-showreel.html": 98,
	"./info-anchor-sp.html": 101,
	"./info-changi-group.html": 107,
	"./info-cisco-security.html": 112,
	"./info-cpf-medishield-life.html": 120,
	"./info-essilor.html": 126,
	"./info-gojek.html": 138,
	"./info-lyfe.html": 152,
	"./info-manulife.html": 162,
	"./info-mckinsey.html": 166,
	"./info-nabei-cat.html": 171,
	"./info-oya.html": 179,
	"./info-starhub.html": 189,
	"./info-uniqlo.html": 197
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 81;